import { CoAuthorForm } from ".";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as RS from "react-select";
import * as Comp from "../../../../components";
import { IComponentWithValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { ReactHelper, Utility } from "../../../../utils";
import { Statuses } from "../../../../domain";

interface OwnProps {
    api: Api;
    authors: Forms.Abstract.ComposeCoAuthorData[];
    formComponent: IComponentWithValidatedForm;
    onAdd: (user: M.Member.BasicProfile) => void;
    onDelete: (index: number) => void;
}

interface OwnState {
    isManual: boolean;
    search: string;
    searching: boolean;
    searchOpen: boolean;
    suggestions: M.Member.BasicProfile[];
}

export class CoAuthorsEditor extends React.Component<OwnProps, OwnState> {

    private _searchTimeout: NodeJS.Timer;

    public constructor(props: any) {
        super(props);
        this.state = {
            isManual: false,
            search: "",
            searching: false,
            searchOpen: false,
            suggestions: [],
        };
    }

    public render() {
        const authors = this.props.authors
            .filter((x) => !x.deleted)
            .map((x, i) => {
                return <li key={i}>
                    <Comp.Reusable.PersonSearchListItem
                        avatar={M.Generic.PersonHelper.getAvatarUrl(x)}
                        email={x.email}
                        name={M.Generic.PersonHelper.getFullName(x)}
                        title={x.title}
                        onDelete={() => this.props.onDelete(x.index)}
                    />
                </li>;
            });

        const saveCancelBtns = this.state.isManual
            ? null
            : <p>
                <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleSearchBox(); }}>Cancel</a>
            </p>;

        const errors = this.props.formComponent.getFieldErrors("authors");

        return <Comp.Generic.WrapperLess>
            <Comp.Editors.FormField name="" label="Co-author(s)" errors={errors}>
                <p className="mute">
                    Your co-author(s) will be contacted by email to update their financial disclosures, if not already on file.
                </p>

                <div className={"authors"} style={{ display: authors.length ? "block" : "none" }}>
                    <ul>
                        {authors}
                    </ul>
                </div>

                <input type="hidden" name="authors" />
            </Comp.Editors.FormField>

            <Comp.Editors.FormField name="">
                <p>
                    <a className="btn btn-default" href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleSearchBox(); }}>
                        <Comp.Generic.Icon icon="plus" /> Add a co-author
                    </a>
                </p>

                <BS.Collapse in={this.state.searchOpen}>
                    <div className="highlight coauthor-form">
                        <h3>Add a co-author</h3>

                        <RS.Async
                            arrowRenderer={(arrowProps) => <button className="search-button" type="button"><Comp.Generic.Icon icon="search" /></button>}
                            className="authors search select-single"
                            filterOptions={(options) => options}
                            ignoreCase
                            loadOptions={(search: string) => this.search(search)}
                            searchPromptText="Start typing and select from suggested"
                            onChange={(user: M.Member.BasicProfile) => { this.props.onAdd(user); this.toggleSearchBox(); }}
                            optionRenderer={(user: M.Member.BasicProfile) => {
                                return <li>
                                    <Comp.Reusable.PersonSearchListItem
                                        avatar={M.Generic.PersonHelper.getAvatarUrl(user)}
                                        email={user.email || ""}
                                        name={M.Generic.PersonHelper.getFullName(user)}
                                        title={user.degrees}
                                    />
                                </li>;
                            }}
                            placeholder="Search..."
                        />

                        <p>
                            <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleManualSearch(); }}>
                                Enter name manually &raquo;
                            </a>
                        </p>

                        <CoAuthorForm
                            api={this.props.api}
                            isAdmin={false}
                            show={this.state.isManual}
                            onCancel={() => this.toggleManualSearch()}
                            onSave={(author) => this.handleAuthorSave(author)}
                        />

                        {saveCancelBtns}
                    </div>
                </BS.Collapse>
            </Comp.Editors.FormField>
        </Comp.Generic.WrapperLess>;
    }

    public toggleManualSearch() {
        this.setState({ ...this.state, isManual: !this.state.isManual });
    }

    public toggleSearchBox() {
        this.setState({ ...this.state, searchOpen: !this.state.searchOpen }, () => {
            if (!this.state.searchOpen)
                this.setState({ ...this.state, isManual: false });
        });
    }

    public handleAuthorSave(author: Forms.Abstract.ComposeNewCoAuthorData) {
        const user: M.Member.BasicProfile = {
            degrees: author.title || "",
            email: author.email || null,
            firstName: author.firstName || "",
            id: 0,
            lastName: author.lastName || "",
            memberId: 0,
            isMember: false,
            statusId: Statuses.Active.id,
            userId: 0,
            username: author.email || "",
        };

        this.setState({
            ...this.state,
            isManual: false,
            searchOpen: false,
        }, () => {
            this.props.onAdd(user);
        });
    }

    public onSearchInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        const search = e.target.value;
        this.setState({ ...this.state, search, searching: search.length > 1 }, () => {
            if (search.length > 1)
                this.search(search);
        });
    }

    public search(query: string) {
        if (!query || query.length < 2)
            return Promise.resolve({ options: [] });

        return new Promise((resolve, reject) => {
            // delay the ajax call as to not make a call for each letter typed.
            if (this._searchTimeout !== undefined)
                clearTimeout(this._searchTimeout);

            this._searchTimeout = setTimeout(() => {
                const queryParams = { queryParams: { query, includeNonMembers: true, max: 25 }};

                this.props.api.callApi(Api.endpoints.members.search, queryParams)
                    .then((result) => {
                        if (result.isSuccess && result.data) {
                            let options = result.data.map((x) => {
                                return Utility.toReactSelectOption(x, M.Generic.PersonHelper.getFullName(x), x.userId);
                            });

                            options = [...options];
                            resolve({ options });
                        }
                        else
                            console.error(result.errors.join("; "));
                    });
            }, 375);
        }).then((data) => {
            return data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/containers/abstracts/composer/components/CoAuthorsEditor.tsx